module.exports = __webpack_public_path__ + "static/media/odejmowanie_w_zakresie_10.c73e3d45.pdf";